/** @jsx jsx */
import { jsx } from "theme-ui"
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
// import 'react-h5-audio-player/lib/styles.less' Use LESS
// import 'react-h5-audio-player/src/styles.scss' Use SASS


const Player = ({audiofile, title}) => {
  let audioUrl="https://ia601403.us.archive.org/8/items/KUKL_1984-09-14/1984-09-14%20L%27Eldorado%2C%20Paris%2C%20France%20%5BKUKL%5D/Kukl1984-09-14_Upgrade_t01.mp3"
  if (audiofile.length < 1) {
    return <div>no link :(</div>
  }

  if (!audiofile.startsWith("http")) {
    audioUrl=`/${audiofile}`
  } else {
    audioUrl = audiofile
  }
  console.log(audioUrl)
  
  return (
    <div className="audioplayer">
      <h3>{title}</h3>
      <AudioPlayer
        // autoPlay
        src={audioUrl}
        onPlay={e => console.log("onPlay")}
        onPlayError={e => console.log(e)}
        layout='horizontal' 
        />
      </div>
)}


export default Player
